import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { Box } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { getReservationList } from "redux/actions/reservationAction";
import { getDateFormat } from "utils/utils";
import CommonSubHeader from "components/commonSubHeader/CommonSubHeader";
import CommonTable from "components/commonTable/CommonTable";
import Loader from "components/loader/Loader";

const ManageInvoice = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const filterPage = searchParams?.get('page');
  const filterRowPerPage = searchParams?.get('rowPerPage');
  const filterSearch = searchParams?.get('search');
  const {state} = useLocation();
  const [page, setPage] = useState(filterPage ? parseInt(filterPage) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(filterRowPerPage ? filterRowPerPage : 10);
  const [search, setSearch] = useState(filterSearch ? filterSearch :"");
  const [dateFrom, setDateFrom] = useState((startDate && startDate !== 'null') ? startDate : startDate === 'null' ? '' : state?.fromTab ? state?.dateFrom:
    getDateFormat(new Date(), "reservationDateFormat")
  );
  let paramsList = {};

  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });

  const [dateTo, setDateTo] = useState((endDate && endDate !== 'null') ? endDate : endDate === 'null' ? '' : state?.fromTab ? state?.dateTo:
    getDateFormat(new Date(), "reservationDateFormat")
  );

  const reservationList = useSelector(
    (state) => state.getReservationList?.reservationList?.data
  );

  const loader = useSelector((state) => state.getReservationList?.loading);
  let filterData = {
    page: page,
    dateFrom:  dateFrom,
    dateTo:  dateTo ,
    status: "completed",
    pageSize: rowsPerPage ? rowsPerPage : "",
    bookingType: "",
    search: search ? search : "",
  };

  useEffect(() => {
    dispatch(getReservationList(filterData));
  }, []);

  const tableOnClickRow = (navigate, val) => {
    navigate(`/manage-invoice/bookingdetails?id=${val.id}&startDate=${dateFrom}&endDate=${dateTo}&type=manage-invoice`);
  };

  const handleChangePage = (event, newPage) => {
    setSearchParams({...paramsList, page:newPage})
    setPage(newPage);
    dispatch(getReservationList({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchParams({...paramsList, rowPerPage:parseInt(event.target.value), page:0})
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getReservationList({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const onSearch = debounce((e) => {
    setSearchParams({...paramsList, page:0, search:e})
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
      pageSize: "",
    };
    dispatch(getReservationList(searchFilterData));
  }, 500);

  const onSelectDateRange = (newValue) => {
    if (newValue === null || newValue === 0) {
      setSearchParams({...paramsList,startDate:'null', endDate:'null', page:0})
      setDateFrom("");
      setDateTo("");
      filterData = { ...filterData, dateFrom: "", dateTo: "" };
    } else {
      setSearchParams({...paramsList,startDate:getDateFormat(newValue[0], 'reservationDateFormat'), endDate:getDateFormat(newValue[1], 'reservationDateFormat'), page:0})
      setDateFrom(getDateFormat(newValue[0], "reservationDateFormat"));
      setDateTo(getDateFormat(newValue[1], "reservationDateFormat"));
      filterData = {
        ...filterData,
        dateFrom: getDateFormat(newValue[0], "reservationDateFormat"),
        dateTo: getDateFormat(newValue[1], "reservationDateFormat"),
      };
    }
    dispatch(getReservationList(filterData));
  };

  return (
    <Box>
      <Box className="mt10 mb30">
        <CommonSubHeader
          onSelectDateRange={onSelectDateRange}
          onSearchQuery={onSearch}
          dateFrom={dateFrom}
          dateTo={dateTo}
          search={search}
        />
      </Box>

      {loader ? (
        <Loader />
      ) : (
        <CommonTable
          data={reservationList}
          isClickable={true}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          tableOnClickRow={tableOnClickRow}
          tabName={"reservation"}
          viewMoreIcon={true}
        />
      )}
    </Box>
  );
};

export default ManageInvoice;
